// extracted by mini-css-extract-plugin
export default {"page":"backgroundPage_page__wSgZ+","yellowLine":"backgroundPage_yellowLine__u8GBX","content":"backgroundPage_content__euu0k","root":"backgroundPage_root__VqiWH"};